import { Component, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '../../../../environments/environment';
import Resources from '../../../core/constants/resources';

import { SessionStorageService } from '../../../core/services/session.service';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss'],
})
export class TopMenuComponent {
  @Output() sendDataToParent = new EventEmitter<string>();

  isShowRef: boolean = false;
  redirectUrl: string;
  firstName: string;

  constructor(
    private router: Router,
    private sessionService: SessionStorageService
  ) {
    // For local only
    if (environment.environment === 'local') {
      this.redirectUrl = 'http://localhost:4200';
    }
    // For test dev
    if (environment.environment === 'dev') {
      this.redirectUrl = 'https://business.dev.thelabrador.co.uk/';
    }
    // For test preprod
    if (environment.environment === 'pre-prod') {
      this.redirectUrl = 'https://business.preprod.thelabrador.co.uk/';
    }
    // For PROD
    if (environment.environment === 'prod') {
        this.isShowRef = true;
        this.redirectUrl = 'https://www.thelabrador.co.uk/business';
    }
  }

  // Toggle menu for drawer
  toggleMenu(): void {
    this.sendDataToParent.emit('open');
  }

  // logout
  logout(): void {
    this.sessionService.resetStorage();
    localStorage.clear();
    this.sendDataToParent.emit('open');
    this.router.navigate(['/login']);
  }

  // isloggedIn
  isLoggedin(): boolean {
    if (this.sessionService.getItemFromMemory('isLoggedInUser')) {
      if (!this.firstName) {
        this.firstName = this.sessionService.getItemFromMemory(Resources.SessionStorageKeys.Username);
      }
      return true;
    } else {
      return false;
    }
  }
}
